import { Dispatch } from 'redux'
import { Store } from '@reduxjs/toolkit'

import * as AuthActions from '../actions/auth.action'

// Interfaces
import { IAuthLoginAction, IOtpAction } from '../../shared/interfaces/action.interface'
import { IService } from '../../shared/interfaces/service.interface'
import { IOtpResponse } from '../../shared/interfaces/otp.interface'
import { IAuthResponse } from '../../shared/interfaces/auth.interface'

const login =
  ({ log, api, toast }: IService) =>
  ({ dispatch }: Store) =>
  (next: Dispatch) =>
  async (action: IAuthLoginAction) => {
    next(action)

    const { type, payload } = action
    if (type === AuthActions.AUTH_LOGIN) {
      try {
        const { data, success, errors }: IAuthResponse = await api.auth.login(payload)
        if (success) {
          dispatch(AuthActions.LoginSuccess(payload, data))
        } else {
          const [{ message }] = errors

          toast('error', message)
          dispatch(AuthActions.LoginError(errors))
        }
      } catch (error: any) {
        log(error)
      }
    }
  }

const otp =
  ({ log, api, storage, toast }: IService) =>
  ({ dispatch }: Store) =>
  (next: Dispatch) =>
  async (action: IOtpAction) => {
    next(action)

    const { type, payload } = action
    if (type === AuthActions.AUTH_OTP) {
      try {
        const { data, success, errors }: IOtpResponse = await api.auth.otp(payload)
        if (success) {
          dispatch(AuthActions.OtpSuccess(data))
          storage.set('user', data)
        } else {
          const [{ message }] = errors

          toast('error', message)
          dispatch(AuthActions.OtpError(errors))
        }
      } catch (error: any) {
        log(error)
      }
    }
  }

const logout =
  ({ toast, storage, log }: IService) =>
  ({ dispatch }: Store) =>
  (next: Dispatch) =>
  (action: any) => {
    next(action)

    const { type } = action

    if (type === AuthActions.AUTH_LOGOUT) {
      storage.clear()
      toast('success', 'Logged out from Online HR Clearance Successfully!')
      dispatch(AuthActions.LogoutSuccess())
    }
  }

const auth = [login, otp, logout]

export default auth
